import { PeriodUnit, AppliedAt } from '@wix/ambassador-pricing-plans-v2-plan/types';
import { StartType, Visibility, Period, AppliedAt as AppliedAtV3 } from '@wix/ambassador-pricing-plans-v3-plan/types';
export function mapPricingV3ToV2(plan) {
  var _pricingVariant$prici, _pricingStrategy$flat, _pricingVariant$fees;
  if (!plan.pricingVariants || plan.pricingVariants.length === 0) {
    throw new Error('Plan must have at least one pricingVariant');
  }
  const pricingVariant = plan.pricingVariants[0];
  const billingTerms = pricingVariant.billingTerms;
  const pricingStrategy = (_pricingVariant$prici = pricingVariant.pricingStrategies) == null ? void 0 : _pricingVariant$prici[0];
  const price = (pricingStrategy == null || (_pricingStrategy$flat = pricingStrategy.flatRate) == null ? void 0 : _pricingStrategy$flat.amount) || '0';
  const pricing = {
    price: {
      value: price,
      currency: plan.currency
    },
    freeTrialDays: pricingVariant.freeTrialDays || 0,
    feeConfigs: ((_pricingVariant$fees = pricingVariant.fees) == null ? void 0 : _pricingVariant$fees.map(fee => {
      var _fee$fixedAmountOptio;
      return {
        fee: {
          name: fee.name,
          amount: (_fee$fixedAmountOptio = fee.fixedAmountOptions) == null ? void 0 : _fee$fixedAmountOptio.amount
        },
        appliedAt: fee.appliedAt === AppliedAtV3.FIRST_PAYMENT ? AppliedAt.FIRST_PAYMENT : undefined
      };
    })) ?? []
  };
  if (billingTerms) {
    if (billingTerms.endType === 'UNTIL_CANCELLED') {
      var _billingTerms$billing;
      if ((_billingTerms$billing = billingTerms.billingCycle) != null && _billingTerms$billing.period) {
        var _billingTerms$billing2, _billingTerms$billing3;
        pricing.subscription = {
          cycleDuration: {
            unit: mapPeriodV3ToV2((_billingTerms$billing2 = billingTerms.billingCycle) == null ? void 0 : _billingTerms$billing2.period),
            count: parseInt(((_billingTerms$billing3 = billingTerms.billingCycle) == null ? void 0 : _billingTerms$billing3.count) || '1', 10)
          },
          cycleCount: 0
        };
      } else {
        pricing.singlePaymentUnlimited = true;
      }
    } else if (billingTerms.endType === 'CYCLES_COMPLETED') {
      var _billingTerms$cyclesC;
      const cycleCount = parseInt(((_billingTerms$cyclesC = billingTerms.cyclesCompletedDetails) == null ? void 0 : _billingTerms$cyclesC.billingCycleCount) || '1', 10);
      if (cycleCount === 1) {
        var _billingTerms$billing4, _billingTerms$billing5;
        pricing.singlePaymentForDuration = {
          unit: mapPeriodV3ToV2((_billingTerms$billing4 = billingTerms.billingCycle) == null ? void 0 : _billingTerms$billing4.period),
          count: parseInt(((_billingTerms$billing5 = billingTerms.billingCycle) == null ? void 0 : _billingTerms$billing5.count) || '1', 10)
        };
      } else {
        var _billingTerms$billing6, _billingTerms$billing7;
        pricing.subscription = {
          cycleDuration: {
            unit: mapPeriodV3ToV2((_billingTerms$billing6 = billingTerms.billingCycle) == null ? void 0 : _billingTerms$billing6.period),
            count: parseInt(((_billingTerms$billing7 = billingTerms.billingCycle) == null ? void 0 : _billingTerms$billing7.count) || '1', 10)
          },
          cycleCount
        };
      }
    }
  }
  return pricing;
}
export function mapPeriodV3ToV2(period) {
  switch (period) {
    case Period.DAY:
      return PeriodUnit.DAY;
    case Period.WEEK:
      return PeriodUnit.WEEK;
    case Period.MONTH:
      return PeriodUnit.MONTH;
    case Period.YEAR:
      return PeriodUnit.YEAR;
    default:
      return undefined;
  }
}
export function mapStartTypeV3ToV2(plan) {
  var _$billingTerms;
  const startType = (_$billingTerms = plan.pricingVariants[0].billingTerms) == null ? void 0 : _$billingTerms.startType;
  switch (startType) {
    case StartType.ON_PURCHASE:
      return false;
    case StartType.CUSTOM:
      return true;
    default:
      throw new Error(`Invalid start type: ${startType}`);
  }
}
export function mapPerksV3ToV2(plan) {
  const perks = plan.perks;
  return {
    values: (perks ?? []).map(perk => perk.description ?? '')
  };
}
export function mapAppliedAtV3ToV2(appliedAt) {
  switch (appliedAt) {
    case AppliedAtV3.FIRST_PAYMENT:
      return AppliedAt.FIRST_PAYMENT;
    case AppliedAtV3.UNKNOWN_APPLIED_AT:
      return AppliedAt.UNKNOWN_CHARGE_EVENT;
    default:
      throw new Error(`Invalid applied at: ${appliedAt}`);
  }
}
function mapClientDataV3ToV2(plan) {
  var _plan$extendedFields;
  const clientData = {};
  if (plan.formType) {
    clientData.type = plan.formType;
  }
  if (plan.image) {
    const coverImage = {
      uri: plan.image.id,
      width: plan.image.width,
      height: plan.image.height
    };
    if (plan.image.altText) {
      coverImage.altText = plan.image.altText;
    }
    clientData.coverImage = JSON.stringify(coverImage);
  }
  if (plan.termsAndConditionsSettings) {
    clientData.termsAndConditionsSettings = JSON.stringify({
      acceptRequired: plan.termsAndConditionsSettings.acceptRequired,
      isAcceptedByDefault: plan.termsAndConditionsSettings.acceptedByDefault
    });
  }
  if (plan.thankYouPageSettings) {
    clientData.thankYouPageSettings = JSON.stringify({
      title: plan.thankYouPageSettings.title,
      message: plan.thankYouPageSettings.message,
      buttonText: plan.thankYouPageSettings.buttonText,
      buttonLink: plan.thankYouPageSettings.buttonLink
    });
  }
  if ((_plan$extendedFields = plan.extendedFields) != null && _plan$extendedFields.namespaces) {
    Object.entries(plan.extendedFields.namespaces).forEach(_ref => {
      let namespace = _ref[0],
        data = _ref[1];
      if (namespace === '@groups/group-settings' && 'groupsAutoJoin' in data) {
        clientData.groups_auto_join = data.groupsAutoJoin.toString();
      }
      if (namespace === '@achievements/online-programs' && 'oProgAutoJoin' in data) {
        clientData.oprog_auto_join = data.oProgAutoJoin.toString();
      }
    });
  }
  return Object.keys(clientData).length > 0 ? clientData : undefined;
}
export function mapPlanV3ToV2(plan) {
  return {
    id: plan.id,
    name: plan.name,
    description: plan.description,
    perks: mapPerksV3ToV2(plan),
    pricing: mapPricingV3ToV2(plan),
    public: plan.visibility === Visibility.PUBLIC,
    archived: plan.archived,
    primary: plan.primary,
    createdDate: plan.createdDate,
    updatedDate: plan.updatedDate,
    slug: plan.slug,
    maxPurchasesPerBuyer: plan.maxPurchasesPerBuyer,
    allowFutureStartDate: mapStartTypeV3ToV2(plan),
    buyerCanCancel: plan.buyerCanCancel,
    termsAndConditions: plan.termsAndConditions,
    formId: plan.formId,
    clientData: mapClientDataV3ToV2(plan),
    hasOrders: false
  };
}
//# sourceMappingURL=plan-mapper-v3-v2.js.map